// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3ozeV","bigColWidth":"Table_bigColWidth__1QLCD","biggerColWidth":"Table_biggerColWidth__fNvI2","row":"Table_row__1TVq4","col":"Table_col__1xrZ3"};